import React from "react"
import serviceIcon1 from "assets/images/service/service-icon-1.svg";
import serviceIcon2 from "assets/images/service/service-icon-2.svg";
import serviceIcon3 from "assets/images/service/service-icon-3.svg";
import serviceIcon4 from "assets/images/service/service-icon-4.svg";
import {FaRobot} from 'react-icons/fa'
import {FaMask} from 'react-icons/fa'
import {CgUnblock} from 'react-icons/cg'
import {CgServerless} from 'react-icons/cg'
import {CgExtensionAdd} from 'react-icons/cg'
export default {
  services: [
    {
      icon: <FaMask size="7.5em" color="white"/>,
      title: "Anónimo",
      body: "Ocultamos tu ip a través de rotadores de proxys",
    },
    {
      icon: <CgUnblock size="7.5em" color="white"/>,
      title: "Anti-captcha",
      body: "Saltamos cualquier barrera que impida el acceso automatizado a los datos",
    },
    {
      icon: <CgServerless size="7.5em" color="white"/>,
      title: "Serverless",
      body: "Implementamos los scrapy en arquitectura AWS serverless (menor costos por uso)",
    },
    {
      icon: <CgExtensionAdd size="7.5em" color="white"/>,
      title: "A medida",
      body: "Conseguimos el dato y lo disponemos como lo necesites",
    },
    
  ],
};
